<mat-card appearance="outlined" class="card-primary task-card">
  <mat-dialog-content class="task-dialog-content">
    @if (teacher) {
      <app-task-teacher [data]="data" [dialogRef]="dialogRef"> </app-task-teacher>
    } @else {
      <app-task-student [data]="data" [dialogRef]="dialogRef"> </app-task-student>
    }
  </mat-dialog-content>
  <button mat-icon-button class="close-button" [mat-dialog-close]="false">
    <mat-icon>clear</mat-icon>
  </button>
</mat-card>
